export default "__VITE_PUBLIC_ASSET__2237cdeb__"